import { define } from "../preactement/define";
import { MonthPicker } from "../../MonthPicker";
import { parseBooleanAttr } from "../wrapperUtils";
import { formAttrs } from "../shared-attributes/form";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['button-variation', 'class-name', 'clear-all-text', 'default-selected-months', 'disabled-months', 'inversed', 'name', 'root-id', 'select-all-text', ...formAttrs];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    children,
    rootId,
    defaultSelectedMonths,
    disabledMonths,
    selectedMonths,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(MonthPicker, {
    ...otherProps,
    id: rootId,
    inversed: parseBooleanAttr(otherProps.inversed),
    defaultSelectedMonths: typeof defaultSelectedMonths === 'string' ? JSON.parse(defaultSelectedMonths) : defaultSelectedMonths,
    disabledMonths: typeof disabledMonths === 'string' ? JSON.parse(disabledMonths) : disabledMonths,
    selectedMonths: typeof selectedMonths === 'string' ? JSON.parse(selectedMonths) : selectedMonths,
    children: children
  });
};
define('ds-month-picker', () => Wrapper, {
  attributes,
  events: ['onChange', 'onSelectAll', 'onClearAll']
});